<template>
  <div class="flex flex-col self-center w-full">
    <div class="mb-8">
      <h2>Gutscheincode manuell eingeben</h2>
      <ValidationObserver v-slot="{ handleSubmit }">
        <form class="w-full flex flex-col" @submit.prevent="handleSubmit(onDecode)">
          <InputField
            id="text"
            v-model="voucherForm.qr"
            type="text"
            class="w-full mb-5"
            rules="required"
            label="Code"
          />
          <Button
            label="Code bestätigen"
            fontWeight="font-normal"
            size="py-4 px-8"
            round="rounded"
            type="submit"
            :useDefaultFont="false"
          />
        </form>
      </ValidationObserver>
    </div>

    <div>
      <h2>Gutscheincode manuell scannen</h2>
      <div v-if="isShowQR" class="w-full">
        <div v-if="error" class="mb-4 p-4 bg-red-100 border border-red-400 text-red-700 rounded">
          {{ error }}
        </div>
        <QrcodeStream :track="true" @decode="$emit('onSetVoucher', $event)" @init="onInit" />
      </div>
      <Button
        :label="isShowQR ? 'Kamera schließen' : 'Kamera öffnen'"
        fontWeight="font-normal"
        size="py-4 px-8"
        round="rounded"
        type="button"
        :useDefaultFont="false"
        @onClick="toggleCamera"
      />
    </div>
  </div>
</template>
<script>
import Button from "_components/Button";
import InputField from "_components/Form/InputField";
import { QrcodeStream } from "vue-qrcode-reader";

export default {
  components: {
    Button,
    InputField,
    QrcodeStream,
  },
  props: [],
  data() {
    return {
      isShowQR: false,
      error: null,
      voucherForm: {
        qr: "",
      },
    };
  },
  mounted() {},
  methods: {
    toggleCamera() {
      this.isShowQR = !this.isShowQR;
      if (!this.isShowQR) {
        this.error = null;
      }
    },
    onDecode() {
      this.$emit("onSetVoucher", this.voucherForm.qr);
    },
    async onInit(promise) {
      try {
        await promise;
        this.error = null;
      } catch (error) {
        if (error.name === "NotAllowedError") {
          this.error = "Fehler: Sie müssen die Kamera-Berechtigung erteilen";
        } else if (error.name === "NotFoundError") {
          this.error = "Fehler: Keine Kamera auf diesem Gerät gefunden";
        } else if (error.name === "NotSupportedError") {
          this.error = "Fehler: Sichere Verbindung erforderlich (HTTPS, localhost)";
        } else if (error.name === "NotReadableError") {
          this.error = "Fehler: Ist die Kamera bereits in Verwendung?";
        } else if (error.name === "OverconstrainedError") {
          this.error = "Fehler: Installierte Kameras sind nicht geeignet";
        } else if (error.name === "StreamApiNotSupportedError") {
          this.error = "Fehler: Stream API wird in diesem Browser nicht unterstützt";
        } else {
          this.error = `Fehler: ${error.message || "Unbekannter Fehler beim Zugriff auf die Kamera"}`;
        }
      }
    },
  },
};
</script>
<style lang="css" scoped>
h2 {
  @apply font-semibold text-peach mb-4;
}
</style>
